import Details from "components/general/Details";
import React, { createContext } from "react";
import useEmailParameters from "../EmailParameters/useEmailParameters";
import { Spinner } from "components/individual/Spinner/Spinner";
import CommentBox from "components/individual/CommentBox";
import Update from "./Update";
import AutocompleteEmail from "components/individual/AutocompleteEmail";

/**
 * @type {import("react").Context<import("../EmailParameters/useEmailParameters/types").ReturnUseEmailParameters|undefined>}
 */
export const ContextReminderPayments = createContext(undefined);

export default function EmailReminderContracts() {
  const hook = useEmailParameters({
    module: "recordatorioContratos",
  });

  if (hook.isLoading)
    return <Spinner text={"Cargando plantilla"} hidden={false} />;

  return (
    <ContextReminderPayments.Provider value={hook}>
      <Details summary="Recordatorio contratos" open>
        <b>TO</b>
        <p>1. Correo del cliente asociado al contrato</p>

        <b>CC</b>
        <p>1. Correos registrados en el campo de abajo</p>

        <AutocompleteEmail
          aditionalEmails={hook.cc}
          onChange={(emails) => hook.setCc(emails)}
          label="Correos con copia"
        />

        <b>Cuerpo del correo</b>
        <CommentBox
          value={hook.body}
          type={"recordatorioContratos"}
          onChange={(content) => hook.setBody(content)}
        />

        <Update />
      </Details>
    </ContextReminderPayments.Provider>
  );
}
